import { Link } from "react-router-dom";
import { MessageCircle, KeyRound, ImagePlus, Heart } from "lucide-react";
import { Reveal } from "../components/Reveal";

const WHATSAPP_INVITE =
  "https://wa.me/393289184238?text=Ciao!%20Ho%20adottato%20un%20bassotto%20della%20Casetta%20e%20vorrei%20il%20codice%20invito%20per%20entrare%20nella%20community%20Le%20Nuove%20Vite.";

const STEPS = [
  {
    icon: Heart,
    title: "Hai adottato un bassotto della Casetta",
    text: "La community Le Nuove Vite è riservata alle famiglie che hanno accolto uno dei nostri cuccioli: un modo per restare in contatto e vedere crescere i fratellini.",
  },
  {
    icon: MessageCircle,
    title: "Chiedi il tuo codice invito",
    text: "Scrivici su WhatsApp: ti risponderemo noi — Luca, Ahmed, Marianna o Gloria — con il tuo codice personale, valido per una sola iscrizione.",
  },
  {
    icon: KeyRound,
    title: "Registrati con il codice",
    text: "Crea il tuo account inserendo il codice invito nella registrazione. Da quel momento la galleria dei ricordi è anche tua.",
  },
  {
    icon: ImagePlus,
    title: "Condividi la nuova vita",
    text: "Carica foto e video del tuo bassotto: dopo il nostro ok saranno visibili a tutta la famiglia allargata della Casetta.",
  },
];

const Iscriviti = () => (
  <main className="mx-auto max-w-3xl px-4 pb-24 sm:px-8">
    <section className="py-14 sm:py-20 text-center">
      <Reveal>
        <p className="eyebrow justify-center">Una community su invito</p>
        <h1
          data-testid="iscriviti-heading"
          className="font-display mt-4 text-4xl font-bold leading-[1.08] tracking-tight text-[#2C2723] sm:text-5xl"
        >
          Come entrare nelle <span className="italic text-[#B85328]">Nuove Vite</span>
        </h1>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-[#5C534B] sm:text-lg">
          Per mantenere la community un luogo sicuro e autentico, l'iscrizione è riservata alle
          famiglie che hanno adottato un bassotto della Casetta.
        </p>
      </Reveal>
    </section>

    <div className="space-y-0">
      {STEPS.map((s, i) => (
        <Reveal key={i} delay={i * 0.08}>
          <div
            data-testid={`iscriviti-step-${i + 1}`}
            className="group grid gap-4 border-t border-[#CFC0B2] py-8 first:border-t-0 sm:grid-cols-[auto_1fr] sm:gap-8"
          >
            <span className="font-display text-4xl font-semibold text-[#CFC0B2] transition-colors duration-500 group-hover:text-[#B85328] sm:text-5xl">
              {String(i + 1).padStart(2, "0")}
            </span>
            <div>
              <h3 className="font-display flex items-center gap-3 text-xl font-semibold text-[#2C2723] sm:text-2xl">
                <s.icon size={20} className="text-[#B85328]" />
                {s.title}
              </h3>
              <p className="mt-2 max-w-lg text-sm leading-relaxed text-[#5C534B] sm:text-base">{s.text}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal delay={0.2}>
      <div className="mt-10 flex flex-col items-center gap-4 rounded-3xl border border-[#E8DFD5] bg-white p-8 text-center sm:flex-row sm:justify-between sm:text-left">
        <div>
          <p className="font-display text-xl font-semibold text-[#2C2723]">Pronto a entrare?</p>
          <p className="mt-1 text-sm text-[#8C7B6E]">Richiedi il codice su WhatsApp, poi registrati.</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          <a
            data-testid="iscriviti-whatsapp-button"
            href={WHATSAPP_INVITE}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 rounded-full bg-[#4A6B5D] px-6 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
          >
            <MessageCircle size={16} /> Richiedi il codice
          </a>
          <Link
            to="/accedi"
            data-testid="iscriviti-register-link"
            className="rounded-full border border-[#1F1A17] px-6 py-3.5 text-sm font-semibold text-[#1F1A17] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#B85328] hover:text-[#B85328]"
          >
            Ho già il codice
          </Link>
        </div>
      </div>
    </Reveal>
  </main>
);

export default Iscriviti;
